import { motion } from 'framer-motion';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      title: 'Contact Us',
      description:
        'Reach out via phone, email, or our contact form with your notarization needs and preferred location',
      icon: 'ri-phone-line',
    },
    {
      number: '02',
      title: 'Schedule Appointment',
      description:
        "We'll confirm your appointment time and location—whether it's your home, office, or a facility",
      icon: 'ri-calendar-check-line',
    },
    {
      number: '03',
      title: 'We Come to You',
      description:
        'We arrive on time with all necessary supplies and credentials for your signing',
      icon: 'ri-map-pin-user-line',
    },
    {
      number: '04',
      title: 'Complete & Done',
      description:
        'Documents are notarized properly, you receive your copies, and we handle any required filing',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  return (
    <section className="py-20 bg-beige">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-navy mb-4">
            How It Works
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto font-body">
            Getting your documents notarized is simple and convenient with our mobile service
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="relative"
            >
              <div className="bg-white rounded-lg p-8 h-full border border-gray-200">
                <div className="flex items-center gap-4 mb-4">
                  <div className="text-5xl font-heading font-bold text-gold/20">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 bg-navy/10 rounded-full flex items-center justify-center">
                    <i className={`${step.icon} text-navy text-xl`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-heading font-bold text-navy mb-3">
                  {step.title}
                </h3>
                <p className="text-base text-gray-600 font-body leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-gold"></i>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
